import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_TYPES } from "@/components_v2/Button/constants";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { useGetUserProfileTypesQuery } from "@/redux/service";
import { skipToken } from "@reduxjs/toolkit/query";

const CompleteProfileTypesBanner = () => {
  const { t } = useTranslation();
  const currentUser = useSelector(selectCurrentUser);

  const { data: userProfileTypes } = useGetUserProfileTypesQuery(
    currentUser ? { user: currentUser.id, pagination: "off" } : skipToken,
  );

  if (!currentUser) return null;

  const hasActiveProfileTypes = userProfileTypes?.some((upt) => upt.isActive);

  if (!hasActiveProfileTypes) return null;

  return (
    <div className="onboarding-actions-card flex flex-col gap-100">
      <p className="body-m-medium">{t("banners.completeProfileTypes.title")}</p>

      <p className="body-s-regular">
        {t("banners.completeProfileTypes.description")}
      </p>

      <BaseButton
        type={BUTTON_TYPES.LINK}
        to={`/users/${currentUser.id}?tab=about`}
      >
        {t("banners.completeProfileTypes.action")}
      </BaseButton>
    </div>
  );
};

export default CompleteProfileTypesBanner;
